// "Single Job Mode" is a setting of the Operation widget (`SelectFabricationOrderAndJobWidget`,
// `data.singleJobMode`), but it is a decision of the WORK CENTRE, not of that widget instance: while it
// is on, the machine must never end up with two active jobs, whichever widget started the second one.
// The screen derives it from the layout and publishes it as `globalData.singleJobMode`, so Planned
// Jobs, its "Show all" modal and the job detail can gate their Start/Join without reading another
// widget's config (which `WidgetGrid` never hands them).

// Provider code of the Operation widget (see `base/WidgetProvider.js`).
export const SINGLE_JOB_MODE_WIDGET_TYPE = 'SelectFabricationOrderAndJobWidget'

/**
 * @param {Array<{ type: string, data?: object }>} widgets The screen's widgets, `data` already parsed
 * @returns {boolean} true when at least one Operation widget of the layout has Single Job Mode on
 */
export const isSingleJobModeEnabled = (widgets = []) => {
  if (!Array.isArray(widgets)) return false
  return widgets.some((widget) => widget?.type === SINGLE_JOB_MODE_WIDGET_TYPE && widget?.data?.singleJobMode === true)
}
